import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiUrlProvider } from "./api-url.provider";
import { IApiResult } from "../shared/models/api-result";
import { ITrainingCourse } from "../shared/models/training-course";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class TrainingCourseService{
  constructor(private http: HttpClient, private apiUrlProvider: ApiUrlProvider) { }
  
  getAll(): Observable<IApiResult<ITrainingCourse[]>>{
    return this.http.get<IApiResult<ITrainingCourse[]>>(`${this.apiUrlProvider.url}/TrainingCourse`);
  }

  add(entity: ITrainingCourse): Observable<IApiResult<ITrainingCourse>>{
    return this.http.post<IApiResult<ITrainingCourse>>(`${this.apiUrlProvider.url}/TrainingCourse`, entity);
  }

  update(entity: ITrainingCourse): Observable<IApiResult<ITrainingCourse>>{
    return this.http.post<IApiResult<ITrainingCourse>>(`${this.apiUrlProvider.url}/TrainingCourse/${entity.id}`, entity);
  }
}